import { render, staticRenderFns } from "./dbFuncList.vue?vue&type=template&id=e2b72ada&scoped=true&"
import script from "./dbFuncList.vue?vue&type=script&lang=js&"
export * from "./dbFuncList.vue?vue&type=script&lang=js&"
import style0 from "./dbFuncList.vue?vue&type=style&index=0&id=e2b72ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b72ada",
  null
  
)

export default component.exports